import {ChangeDetectionStrategy, Component, Inject, ViewEncapsulation} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {State} from '../../../shared/store';
import {FormHelper} from '../../../shared/helpers/form-helper';

@Component({
    selector: 'app-test-send-modal',
    templateUrl: './test-send-modal.component.html',
    styleUrls: ['./test-send-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class TestSendModalComponent {
    public form: UntypedFormGroup;

    constructor(private formBuilder: UntypedFormBuilder,
                private dialog: MatDialogRef<TestSendModalComponent>,
                private store: Store<State>,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        const email = data.candidate ? data.candidate.email : '';
        this.form = this.formBuilder.group({
            email: [email, [Validators.required, Validators.email]],
            when_to_send: [''],
            when_to_send_time: [''],
        });
    }

    save(): void {
        if (this.form.valid) {
            this.dialog.close({
                result: 'yes',
                data: this.form.getRawValue()
            });
        } else {
            FormHelper.validateAllFormFields(this.form);
        }
    }
}
